var _ellipse, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOwlOnly(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 250 250",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 125.44,
    cy: 130.99,
    rx: 124.84,
    ry: 118.85,
    fill: "#a89984",
    strokeWidth: 0.50004
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.48807 0 0 .5123 .49576 -6.3584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m302.72 351.44-40.219-56c-1.508-2.094-3.922-3.336-6.5-3.336h-0.023c-2.578 8e-3 -5 1.258-6.5 3.367l-39.781 56c-1.781 2.508-1.969 5.828-0.469 8.516l40 72c1.406 2.539 4.086 4.117 6.992 4.117s5.586-1.578 6.992-4.117l40-72c1.508-2.703 1.312-6.031-0.492-8.547z",
    fill: "#fabd2f"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.48807 0 0 .5123 .49576 -6.3584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m249.48 295.48-39.781 56c-1.781 2.508-1.969 5.828-0.469 8.516l40 72c1.37 2.474 3.954 4.009 6.773 4.088v-143.97h-0.023c-2.578 8e-3 -5 1.258-6.5 3.368z",
    fill: "#d79921"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.48807 0 0 .5123 .49576 -6.3584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m376 157.22c-53.829-7.459-101.5 23.404-119.89 69.182-18.398-45.779-66.066-76.642-119.9-69.182-49.922 6.919-89.733 48.001-95.284 98.093-7.489 67.585 45.219 124.8 111.29 124.8 41.549 0 77.757-22.652 97.077-56.259 2.989-5.2 10.639-5.2 13.628 0 19.32 33.607 55.527 56.259 97.076 56.259 66.07 0 118.78-57.211 111.29-124.8-5.552-50.092-45.363-91.174-95.285-98.092z",
    fill: "#ebdbb2"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.48807 0 0 .5123 .49576 -6.3584)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 268.11,
    r: 72,
    fill: "#928374"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.48807 0 0 .5123 .49576 -6.3584)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 268.11,
    r: 72,
    fill: "#928374"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.48807 0 0 .5123 .49576 -6.3584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m400 76.109h40c30.875 0 56-25.125 56-56 0-4.422 3.578-8 8-8s8 3.578 8 8v96c0 39.703-32.297 72-72 72h-96c-44.109 0-80 35.891-80 80 0 4.422-3.578 8-8 8s-8-3.578-8-8v-40c0-83.812 68.187-152 152-152z",
    fill: "#928374"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.48807 0 0 .5123 .49576 -6.3584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m112.22 76.109h-40c-30.875 0-56-25.125-56-56 0-4.422-3.578-8-8-8s-8 3.578-8 8v96c0 39.703 32.297 72 72 72h96c44.109 0 80 35.891 80 80 0 4.422 3.578 8 8 8s8-3.578 8-8v-40c0-83.812-68.188-152-152-152z",
    fill: "#928374"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.48807 0 0 .5123 .49576 -6.3584)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 152.22,
    cy: 268.11,
    r: 48,
    fill: "#fabd2f"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.48807 0 0 .5123 .49576 -6.3584)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 268.11,
    r: 48,
    fill: "#fabd2f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 268.11,
    r: 24,
    fill: "#5c546a"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-207.78)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 268.11,
    r: 24,
    fill: "#5c546a"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.48807 0 0 .5123 .49576 -6.3584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m504.22 12.109c-4.422 0-8 3.578-8 8 0 30.875-25.125 56-56 56h-40c-67.028 0-123.95 43.663-144.11 104-20.156-60.336-77.082-104-144.11-104h-40c-30.875 0-56-25.125-56-56 0-4.422-3.578-8-8-8s-8 3.578-8 8v48c0 30.928 25.072 56 56 56h56c54.303 0 101.86 28.707 128.68 71.684 3.288 5.27 9.202 8.316 15.413 8.316h0.043c6.211 0 12.125-3.046 15.413-8.316 26.816-42.977 74.372-71.684 128.68-71.684h56c30.928 0 56-25.072 56-56v-48c0-4.422-3.579-8-8-8z",
    fill: "#ebdbb2"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4625 -.10248 .10591 .47798 92.519 300.84)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m263.69-306.06c0.636-4.258-2.606-6.547-7.039-8.074l1.438-5.768-3.512-0.875-1.4 5.616c-0.922-0.23-1.87-0.447-2.812-0.662l1.41-5.653-3.509-0.875-1.439 5.766c-0.764-0.174-1.514-0.346-2.242-0.527l4e-3 -0.018-4.842-1.209-0.934 3.75s2.605 0.597 2.55 0.634c1.422 0.355 1.68 1.296 1.636 2.042l-1.638 6.571c0.098 0.025 0.225 0.061 0.365 0.117l-0.37-0.092-2.297 9.205c-0.174 0.432-0.615 1.08-1.609 0.834 0.035 0.051-2.552-0.637-2.552-0.637l-1.743 4.02 4.57 1.139c0.85 0.213 1.683 0.436 2.502 0.646l-1.453 5.835 3.507 0.875 1.44-5.772c0.957 0.26 1.887 0.5 2.797 0.726l-1.434 5.745 3.511 0.875 1.453-5.823c5.987 1.133 10.49 0.676 12.383-4.738 1.527-4.36-0.075-6.875-3.225-8.516 2.294-0.531 4.022-2.04 4.483-5.157zm-8.023 11.249c-1.086 4.36-8.426 2.004-10.807 1.412l1.928-7.729c2.38 0.594 10.011 1.77 8.88 6.317zm1.085-11.312c-0.99 3.966-7.1 1.951-9.083 1.457l1.748-7.01c1.983 0.494 8.367 1.416 7.335 5.553z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.46169 -.10604 .10959 .47715 -7.7235 301.48)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m263.69-306.06c0.636-4.258-2.606-6.547-7.039-8.074l1.438-5.768-3.512-0.875-1.4 5.616c-0.922-0.23-1.87-0.447-2.812-0.662l1.41-5.653-3.509-0.875-1.439 5.766c-0.764-0.174-1.514-0.346-2.242-0.527l4e-3 -0.018-4.842-1.209-0.934 3.75s2.605 0.597 2.55 0.634c1.422 0.355 1.68 1.296 1.636 2.042l-1.638 6.571c0.098 0.025 0.225 0.061 0.365 0.117l-0.37-0.092-2.297 9.205c-0.174 0.432-0.615 1.08-1.609 0.834 0.035 0.051-2.552-0.637-2.552-0.637l-1.743 4.02 4.57 1.139c0.85 0.213 1.683 0.436 2.502 0.646l-1.453 5.835 3.507 0.875 1.44-5.772c0.957 0.26 1.887 0.5 2.797 0.726l-1.434 5.745 3.511 0.875 1.453-5.823c5.987 1.133 10.49 0.676 12.383-4.738 1.527-4.36-0.075-6.875-3.225-8.516 2.294-0.531 4.022-2.04 4.483-5.157zm-8.023 11.249c-1.086 4.36-8.426 2.004-10.807 1.412l1.928-7.729c2.38 0.594 10.011 1.77 8.88 6.317zm1.085-11.312c-0.99 3.966-7.1 1.951-9.083 1.457l1.748-7.01c1.983 0.494 8.367 1.416 7.335 5.553z",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwlOnly);
export default __webpack_public_path__ + "static/media/owl-only.0c3b5cbf.svg";
export { ForwardRef as ReactComponent };